import React, { useState } from "react";
import Dropdown from "../../../components/Dropdown";
import OneCheckBox from "../../../components/OneCheckBox";
import ButtonPrimary from "../../../components/ButtonPrimary";
import TableLogComponents from "../../../components/TableLogComponents";
export default function AddIllnessDialog({
  isShow,
  backgroundClick,
  cancelClick,
}) {
  return (
    <div className="box-position-dialog" id={isShow ? "show-dialog" : ""}>
      <div
        className="box-cover-dialog-background"
        onClick={backgroundClick}
      ></div>
      <div className="box-dialog">
        <div className="row-jcct-pt2">
          <p style={{ color: "#134e96" }} className="txt-main-content4">
            Add illness
          </p>
        </div>
        <div className="box-table-inside-dialog">
          <TableLogComponents
            columns={[
              {
                title: "No",
                dataIndex: "no",
                key: "no",
              },
              {
                title: "First Name",
                dataIndex: "firstname",
                key: "firstname",
              },
              {
                title: "Last Name",
                dataIndex: "lastname",
                key: "lastname",
              },
              {
                title: "ID",
                dataIndex: "id",
                key: "id",
              },
            ]}
            dataSource={[
              {
                no: "1",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "2",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "3",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
              {
                no: "4",
                firstname: "firstname 1",
                lastname: "lastname 1",
                id: "ID 1",
              },
            ]}
          />
        </div>
        <div className="row-jcsb-px2-gab2">
          <div className="col-jcfs-w100">
            <p className="txt-main-content4">Symptom</p>
            <Dropdown
              styles={{ zIndex: "1001" }}
              items={["Headache", "Sick"]}
              itemCallback={(item) => {
                console.log(item);
              }}
              hasFilter={false}
            />
            <p className="txt-main-content4">Drug</p>
            <Dropdown
              items={["Baclofen", "Paracetamal"]}
              itemCallback={(item) => {
                console.log(item);
              }}
              hasFilter={false}
            />
          </div>
          <div className="col-jcfs-w100-gab1">
            <div className="col-jcfs">
              <OneCheckBox callBack={(state) => {}} title={"Leave at home"} />
              <div className="row-jcct-gab2">
                <input className="text-field"></input>
                <p className="txt-main-content4">Days</p>
              </div>
            </div>
            <div className="col-jcfs">
              <OneCheckBox
                callBack={(state) => {}}
                title={"Leave at the Nursing room"}
              />
              <div className="row-jcct-gab2">
                <input className="text-field"></input>
                <p className="txt-main-content4">Hours</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row-jcsb-px2-gab2">
          <div className="col-jcfs-w100">
            <p className="txt-main-content4">Reason</p>
            <textarea
              id="w3review"
              name="w3review"
              rows="4"
              cols="50"
              className="text-field"
              placeholder="Remark"
            ></textarea>
          </div>
        </div>
        <div className="row-jcct-py2-gab2">
          <ButtonPrimary
            text={"Cancel"}
            className={"text-button"}
            onClick={cancelClick}
          />
          <ButtonPrimary text={"Ok"} className={"primary-button2"} />
        </div>
      </div>
    </div>
  );
}
